import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { useQueries } from '@tanstack/react-query';

const isTruthy = <T>(value: T): value is NonNullable<T> => value !== undefined && value !== null;

export function useOptionalQuery<
  TQueryFunctionData = unknown,
  TError = unknown,
  TData = TQueryFunctionData,
  TQueryKey extends QueryKey = QueryKey,
>(options: UseQueryOptions<TQueryFunctionData, TError, TData, TQueryKey> | undefined) {
  const [query] = useQueries({
    queries: [options].filter(isTruthy),
  });

  return query;
}
